export default {
  id: 'slack_leaderboard_group',
  title: 'Leaderboard group',
  type: 'Group',
  description: 'Slack the current standings of the leaderboard without including the current user.',
  body: {
    blocks: [
      {
        type: 'section',
        text: {
          type: 'mrkdwn',
          text: '[[INPUT_INTRODUCTION_TEXT]]'
        }
      },
      {
        type: 'divider'
      },
      {
        type: 'context',
        elements: [
          {
            type: 'mrkdwn',
            text: '🥇'
          },
          {
            type: 'mrkdwn',
            text: '{{LEADERBOARD_FIRST_NAME}}'
          },
          {
            type: 'mrkdwn',
            text: '-'
          },
          {
            type: 'mrkdwn',
            text: '{{LEADERBOARD_FIRST_POINTS}} points'
          }
        ]
      },
      {
        type: 'context',
        elements: [
          {
            type: 'mrkdwn',
            text: '🥈'
          },
          {
            type: 'mrkdwn',
            text: '{{LEADERBOARD_SECOND_NAME}}'
          },
          {
            type: 'mrkdwn',
            text: '-'
          },
          {
            type: 'mrkdwn',
            text: '{{LEADERBOARD_SECOND_POINTS}} points'
          }
        ]
      },
      {
        type: 'context',
        elements: [
          {
            type: 'mrkdwn',
            text: '🥉'
          },
          {
            type: 'mrkdwn',
            text: '{{LEADERBOARD_THIRD_NAME}}'
          },
          {
            type: 'mrkdwn',
            text: '-'
          },
          {
            type: 'mrkdwn',
            text: '{{LEADERBOARD_THIRD_POINTS}} points'
          }
        ]
      },
      {
        type: 'divider'
      },
      {
        type: 'section',
        text: {
          type: 'mrkdwn',
          text: '[[INPUT_END_TEXT]]'
        }
      }
    ]
  },
  inputs: {
    INPUT_INTRODUCTION_TEXT: {
      label: 'Intro',
      placeholder: 'Hi all, please see the current standing of the leaderboard below...',
      defaultValue: '<p>Hi all,</p><p>Please see the current standings of the leaderboard below.</p>',
      type: 'HTML'
    },
    INPUT_END_TEXT: {
      label: 'Text after leaderboard',
      placeholder: 'Don\'t forget to come back to the platform...',
      defaultValue: '<p>Don\'t forget to come back to the platform to earn more points and win awesome results.</p><p>{{PLATFORM_LINK}}<p>',
      type: 'HTML'
    }
  }
};



// WEBPACK FOOTER //
// ./src/views/campaign-admin/templates/slack/leaderboardOverall.js